export default "__VITE_ASSET__5TO_XDjC__"